import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import { BotanicalDivider } from "../components/Botanical";

const ease = [0.22, 1, 0.36, 1];

const Pricing = () => {
  const [pricing, setPricing] = useState(null);

  useEffect(() => {
    api.get("/pricing").then((res) => setPricing(res.data)).catch(() => {});
  }, []);

  return (
    <section id="pricing" className="relative py-24 md:py-32" data-testid="pricing-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease }}
          className="text-center mb-16"
        >
          <p className="text-xs uppercase tracking-[0.3em] font-semibold text-[#8B5D6C] mb-4">Price List</p>
          <h2 className="font-serif text-4xl md:text-5xl text-[#4A2834]">Honest pricing for handmade work</h2>
          <BotanicalDivider className="w-64 mx-auto mt-6 text-[#C5A059]" />
          <p className="mt-6 max-w-2xl mx-auto text-[#70505D] text-sm md:text-base leading-relaxed">
            Straight from the studio price list — every order is confirmed personally
            by Lall before anything is baked.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7" data-testid="pricing-grid">
          {(pricing?.sections || []).map((section, i) => (
            <motion.div
              key={section.id}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: (i % 3) * 0.1, ease }}
              className={`bg-[#F3EEE6]/80 border border-[#C5A059]/25 rounded-3xl p-8 hover:border-[#C5A059]/60 hover:shadow-xl hover:shadow-[#8B5D6C]/10 transition-all duration-500 ${
                section.id === "delivery" ? "md:col-span-2 lg:col-span-3" : ""
              }`}
              data-testid={`pricing-card-${section.id}`}
            >
              <h3 className="font-serif text-2xl md:text-3xl text-[#4A2834]">{section.title}</h3>
              <span className="gold-rule w-12 block my-5" />
              <ul className={`space-y-4 ${section.id === "delivery" ? "md:grid md:grid-cols-2 md:gap-8 md:space-y-0" : ""}`}>
                {section.items.map((item) => (
                  <li key={item.id} className="flex items-baseline gap-3">
                    <span className="text-sm md:text-base text-[#70505D]">{item.name}</span>
                    <span className="flex-1 border-b border-dotted border-[#8B5D6C]/30" />
                    <span className="font-serif text-lg md:text-xl text-[#8B5D6C] whitespace-nowrap">{item.price}</span>
                  </li>
                ))}
              </ul>
              {section.note && <p className="mt-6 text-xs italic text-[#987885]">{section.note}</p>}
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease }}
          className="mt-10 rounded-3xl border border-[#C5A059]/30 bg-[#F5EBE8]/70 p-8 md:p-10 text-center"
          data-testid="booking-info"
        >
          <p className="text-xs uppercase tracking-[0.3em] font-semibold text-[#8B5D6C] mb-4">Booking Information</p>
          <p className="font-serif text-xl md:text-2xl text-[#4A2834] leading-relaxed max-w-3xl mx-auto">
            A 50% non-refundable deposit secures your date — the remaining balance is due
            48 hours before collection or delivery.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Pricing;
